import { Button, Link, makeStyles} from "@material-ui/core"
import { useEthers } from "@usedapp/core"


const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1)
  },
}))

export const Header = () => {
  const classes = useStyles()

  const { account, activateBrowserWallet, deactivate } = useEthers()

  const isConnected = account !== undefined
  var test =""
  if(isConnected){
   test = "https://polygonscan.com/address/"+account;
}
  return (
    <div className={classes.container}>
      <Button color="primary" variant="contained">
      <a  className="buttonD" href="https://3dHearts.org" rel="noopener noreferrer">Home</a>
      </Button>
      <Button color="primary" variant="contained">
      <a  className="buttonD" href="https://opensea.io/collection/3d-mouse-hearts/" rel="noopener noreferrer">OpenSea</a>
      </Button>

      
      {isConnected ? (
        <>
          <Button color="primary" variant="contained">
          <a  className="buttonD" href={test} rel="noopener noreferrer">{`${account?.slice(0, 4)}...${account?.slice(-3)}`}</a>
          </Button>
          <Button variant="contained" onClick={deactivate}>
            Disconnect
          </Button>
        </>
      ) : (
        <Button
          className="buttonW"
          color="primary"
          size="large"
          variant="contained"
          onClick={() => activateBrowserWallet()}
        >
          Connect
        </Button>
      )}
    </div>
  )
}